// extracted by mini-css-extract-plugin
export default {"saleDetailsError":"SaleDetailsError__saleDetailsError-cnjF","title":"SaleDetailsError__title-AtjK","description":"SaleDetailsError__description-QWy8"};